import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import service from '../../service';
import { toastError } from '@art-of-hospitality-solutions-llc/ui-kit/components/toast';
import { useMessages } from '../../contexts/messages';
import { DateTime } from 'luxon';
import BreadcrumbWrapper from '../BreadcrumbWrapper/index';
import PreviewEmailHtml from '../PreviewEmailHtml';
import { Separator } from '@art-of-hospitality-solutions-llc/ui-kit/components/separator';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/tabs';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from '../Card/index';

const MessageTemplateDetails = () => {
  const { id } = useParams();
  const [targetTemplate, setTargetTemplate] = useState({});
  const [loading, setLoading] = useState(true);
  const [defaultTab, setDefaultTab] = useState(null);
  const { isHtmlDesignBlank } = useMessages();
  const navigate = useNavigate();

  useEffect(() => {
    service
      .getMessageTemplate(id)
      .then((template) => {
        setTargetTemplate(template);
        setLoading(false);
      })
      .catch(() => {
        toastError('Failed to load template');
        navigate('/message-templates');
      });
  }, [id, navigate]);

  useEffect(() => {
    if (targetTemplate?.id) {
      let tab;
      if (isHtmlDesignBlank(targetTemplate?.htmlEditorJson)) {
        tab = 'plainText';
      } else {
        tab = 'html';
      }
      setDefaultTab(tab);
    }
  }, [targetTemplate]);

  return (
    <div>
      <BreadcrumbWrapper
        crumbArray={[
          { path: '/message-templates', label: 'Message Templates' },
          { path: `/message-templates/${id}`, label: 'Template Details' },
        ]}
      />
      <div className="mt-4">
        <h1 className="mb-4 text-2xl font-bold">Template Details</h1>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="my-4">
              <Card>
                <CardHeader>
                  <CardTitle>Title: {targetTemplate?.name || 'N/A'}</CardTitle>
                  <CardDescription>
                    Channel: {targetTemplate?.method || 'N/A'}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="flex">
                    <div className="mx-1 flex flex-col gap-1">
                      <span>
                        Created By:{' '}
                        {targetTemplate?.createdByUser?.name || 'N/A'}
                      </span>
                      <Separator />
                      <span>
                        Create At:{' '}
                        {targetTemplate?.createdAt
                          ? DateTime.fromISO(
                              targetTemplate?.createdAt,
                            ).toFormat('MMM dd, yyyy h:mm a')
                          : 'N/A'}
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            <div className="my-4">
              <div className="">
                <h1 className="mb-2 text-2xl font-bold">Message</h1>
              </div>
              <Card>
                {targetTemplate?.messageSubject && (
                  <CardHeader>
                    <CardTitle>
                      Subject: {targetTemplate?.messageSubject || 'N/A'}
                    </CardTitle>
                  </CardHeader>
                )}
                <CardContent>
                  {defaultTab && (
                    <div>
                      <Tabs defaultValue={defaultTab}>
                        <TabsList>
                          <TabsTrigger value="plainText">
                            Message Body
                          </TabsTrigger>
                          {targetTemplate?.method === 'EMAIL' && (
                            <TabsTrigger value="html">HTML</TabsTrigger>
                          )}
                        </TabsList>
                        <TabsContent value="plainText">
                          <div className="min-h-30 rounded-md border-1 bg-[#fff] px-2 py-1 whitespace-pre-wrap">
                            {targetTemplate?.messageBody || 'N/A'}
                          </div>
                        </TabsContent>
                        <TabsContent value="html">
                          {targetTemplate?.html && (
                            <PreviewEmailHtml html={targetTemplate.html} />
                          )}
                          {!targetTemplate?.html && 'N/A'}
                        </TabsContent>
                      </Tabs>
                    </div>
                  )}
                </CardContent>
              </Card>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MessageTemplateDetails;
